// extracted by mini-css-extract-plugin
export default {"LanguageSelector":"_LanguageSelector--OReDO","FieldDescription":"_FieldDescription--Z6615","Label":"_Label--pJbGI"};